export const isProdEnvironment = () => {
    const hostname = window?.location?.hostname
    return /^traigo.com/.test(hostname)
}
